<p-confirmDialog appendTo="body"></p-confirmDialog>
<app-lazy-shell-overlays></app-lazy-shell-overlays>
<div class="parent"
  [class.immersive-mobile]="isImmersiveMobileRoute"
  [class.sidebar-compact]="isSidebarCompact && sidenavMode === 'side'">
    <mat-sidenav-container class="children" [class.full-size]="fullSize">
    <mat-sidenav
      class="left main"
      [mode]="sidenavMode"
      [opened]="!fullSize"
      (openedChange)="onSidenavOpenedChange($event)"
      aria-label="Navegación principal">
      <div class="sidenav-inner">
        <div class="sidebar-brand">
          <div class="logo">
            <img [src]="commonService.currentLogo" alt="Hacienda del Sol Furniture">
          </div>
        </div>
        <label class="sidebar-search">
          <mat-icon aria-hidden="true">search</mat-icon>
          <input
            class="sidebar-search-input"
            type="search"
            [value]="menuSearchTerm"
            (input)="updateMenuSearch($event)"
            placeholder="Buscar..."
            aria-label="Buscar módulos">
        </label>
        <ul class="_menu">
          @if (modulesAccess.panel && isMenuItemVisible('Panel operativo')) {
            <li>
              <button class="nav-button" mat-button color="accent" [routerLink]="['panel-operativo']" appNavigationIntentPreload routerLinkActive="active-button" aria-label="Panel operativo" matTooltip="Panel operativo" [matTooltipDisabled]="!isSidebarCompact || sidenavMode !== 'side'" matTooltipPosition="right">
                <mat-icon aria-hidden="true">space_dashboard</mat-icon><span class="menu-label">Panel operativo</span>
              </button>
            </li>
          }
          @if (modulesAccess.panel && isMenuItemVisible('NAV.PANEL' | translate)) {
            <li>
              <button class="nav-button" mat-button color="accent" [routerLink]="['panel']" appNavigationIntentPreload routerLinkActive="active-button" [attr.aria-label]="'NAV.PANEL' | translate" [matTooltip]="'NAV.PANEL' | translate" [matTooltipDisabled]="!isSidebarCompact || sidenavMode !== 'side'" matTooltipPosition="right">
                <mat-icon aria-hidden="true">{{ dashboardIcon }}</mat-icon><span class="menu-label">{{ 'NAV.PANEL' | translate }}</span>
              </button>
            </li>
          }
          @if (modulesAccess.arqueo && isMenuItemVisible('NAV.ARQUEO' | translate)) {
            <li>
              <button class="nav-button" mat-button color="accent" [routerLink]="['arqueo']" appNavigationIntentPreload routerLinkActive="active-button" [attr.aria-label]="'NAV.ARQUEO' | translate" [matTooltip]="'NAV.ARQUEO' | translate" [matTooltipDisabled]="!isSidebarCompact || sidenavMode !== 'side'" matTooltipPosition="right">
                <mat-icon aria-hidden="true">{{ arqueoIcon }}</mat-icon><span class="menu-label">{{ 'NAV.ARQUEO' | translate }}</span>
              </button>
            </li>
          }
          @if (modulesAccess.sales && isMenuItemVisible('NAV.SALES' | translate)) {
            <li>
              <button class="nav-button" mat-button color="accent" [routerLink]="['ventas']" appNavigationIntentPreload routerLinkActive="active-button" [attr.aria-label]="'NAV.SALES' | translate" [matTooltip]="'NAV.SALES' | translate" [matTooltipDisabled]="!isSidebarCompact || sidenavMode !== 'side'" matTooltipPosition="right">
                <mat-icon aria-hidden="true">{{ ventasIcon }}</mat-icon><span class="menu-label">{{ 'NAV.SALES' | translate }}</span>
              </button>
            </li>
          }
          @if (modulesAccess.rtm && isMenuItemVisible('NAV.LOGISTICS' | translate)) {
            <li>
              <button class="nav-button" mat-button color="accent" [routerLink]="['agenda']" appNavigationIntentPreload routerLinkActive="active-button" [attr.aria-label]="'NAV.LOGISTICS' | translate" [matTooltip]="'NAV.LOGISTICS' | translate" [matTooltipDisabled]="!isSidebarCompact || sidenavMode !== 'side'" matTooltipPosition="right">
                <mat-icon aria-hidden="true">{{ rtmIcon }}</mat-icon><span class="menu-label">{{ 'NAV.LOGISTICS' | translate }}</span>
              </button>
            </li>
          }
          @if (modulesAccess.inventory && isMenuItemVisible('NAV.WAREHOUSE' | translate)) {
            <li>
              <button class="nav-button" mat-button color="accent" [routerLink]="['inventario']" appNavigationIntentPreload routerLinkActive="active-button" [attr.aria-label]="'NAV.WAREHOUSE' | translate" [matTooltip]="'NAV.WAREHOUSE' | translate" [matTooltipDisabled]="!isSidebarCompact || sidenavMode !== 'side'" matTooltipPosition="right">
                <mat-icon aria-hidden="true">{{ invetoryIcon }}</mat-icon><span class="menu-label">{{ 'NAV.WAREHOUSE' | translate }}</span>
              </button>
            </li>
          }
          @if (modulesAccess.purchases && isMenuItemVisible('NAV.PURCHASES' | translate)) {
            <li>
              <button class="nav-button" mat-button color="accent" [routerLink]="['compras-v2']" appNavigationIntentPreload routerLinkActive="active-button" [attr.aria-label]="'NAV.PURCHASES' | translate" [matTooltip]="'NAV.PURCHASES' | translate" [matTooltipDisabled]="!isSidebarCompact || sidenavMode !== 'side'" matTooltipPosition="right">
                <mat-icon aria-hidden="true">{{ comprasIcon }}</mat-icon><span class="menu-label">{{ 'NAV.PURCHASES' | translate }}</span>
              </button>
            </li>
          }
          @if (modulesAccess.visual && isMenuItemVisible('NAV.VISUAL' | translate)) {
            <li>
              <button class="nav-button" mat-button color="accent" [routerLink]="['visual']" appNavigationIntentPreload routerLinkActive="active-button" [attr.aria-label]="'NAV.VISUAL' | translate" [matTooltip]="'NAV.VISUAL' | translate" [matTooltipDisabled]="!isSidebarCompact || sidenavMode !== 'side'" matTooltipPosition="right">
                <mat-icon aria-hidden="true">{{ visualIcon }}</mat-icon><span class="menu-label">{{ 'NAV.VISUAL' | translate }}</span>
              </button>
            </li>
          }
          @if (modulesAccess.admin && isMenuItemVisible('NAV.ADMIN' | translate)) {
            <li>
              <button class="nav-button" mat-button color="accent" [routerLink]="['administracion']" appNavigationIntentPreload routerLinkActive="active-button" [attr.aria-label]="'NAV.ADMIN' | translate" [matTooltip]="'NAV.ADMIN' | translate" [matTooltipDisabled]="!isSidebarCompact || sidenavMode !== 'side'" matTooltipPosition="right">
                <mat-icon aria-hidden="true">{{ adminIcon }}</mat-icon><span class="menu-label">{{ 'NAV.ADMIN' | translate }}</span>
              </button>
            </li>
          }
          @if (modulesAccess.inventoryCatalog && isMenuItemVisible('INV.BREADCRUMB.INVENTORY' | translate)) {
            <li>
              <button class="nav-button" mat-button color="accent" [routerLink]="['inventario-consulta']" appNavigationIntentPreload routerLinkActive="active-button" [attr.aria-label]="'INV.BREADCRUMB.INVENTORY' | translate" [matTooltip]="'INV.BREADCRUMB.INVENTORY' | translate" [matTooltipDisabled]="!isSidebarCompact || sidenavMode !== 'side'" matTooltipPosition="right">
                <mat-icon aria-hidden="true">{{ invetoryIcon }}</mat-icon><span class="menu-label">{{ 'INV.BREADCRUMB.INVENTORY' | translate }}</span>
              </button>
            </li>
          }
          @if (modulesAccess.prices && isMenuItemVisible('NAV.PRICES' | translate)) {
            <li class="menu-section-start">
              <button class="nav-button" mat-button color="accent" [routerLink]="['precios']" appNavigationIntentPreload routerLinkActive="active-button" [attr.aria-label]="'NAV.PRICES' | translate" [matTooltip]="'NAV.PRICES' | translate" [matTooltipDisabled]="!isSidebarCompact || sidenavMode !== 'side'" matTooltipPosition="right">
                <mat-icon aria-hidden="true">{{ pricesIcon }}</mat-icon><span class="menu-label">{{ 'NAV.PRICES' | translate }}</span>
              </button>
            </li>
          }
          @if (modulesAccess.users && isMenuItemVisible('NAV.USERS' | translate)) {
            <li>
              <button class="nav-button" mat-button color="accent" [routerLink]="['usuarios']" appNavigationIntentPreload routerLinkActive="active-button" [attr.aria-label]="'NAV.USERS' | translate" [matTooltip]="'NAV.USERS' | translate" [matTooltipDisabled]="!isSidebarCompact || sidenavMode !== 'side'" matTooltipPosition="right">
                <mat-icon aria-hidden="true">{{ usersIcon }}</mat-icon><span class="menu-label">{{ 'NAV.USERS' | translate }}</span>
              </button>
            </li>
          }
          @if (modulesAccess.history && isMenuItemVisible('NAV.HISTORY' | translate)) {
            <li>
              <button class="nav-button" mat-button color="accent" [routerLink]="['historial']" appNavigationIntentPreload routerLinkActive="active-button" [attr.aria-label]="'NAV.HISTORY' | translate" [matTooltip]="'NAV.HISTORY' | translate" [matTooltipDisabled]="!isSidebarCompact || sidenavMode !== 'side'" matTooltipPosition="right">
                <mat-icon aria-hidden="true">{{ historyIcon }}</mat-icon><span class="menu-label">{{ 'NAV.HISTORY' | translate }}</span>
              </button>
            </li>
          }
          @if (modulesAccess.salesbinder && isMenuItemVisible('NAV.SYNC_SB' | translate)) {
            <li>
              <button class="nav-button" mat-button color="accent" [routerLink]="['sincronizacion-salesbinder']" appNavigationIntentPreload routerLinkActive="active-button" [attr.aria-label]="'NAV.SYNC_SB' | translate" [matTooltip]="'NAV.SYNC_SB' | translate" [matTooltipDisabled]="!isSidebarCompact || sidenavMode !== 'side'" matTooltipPosition="right">
                <mat-icon aria-hidden="true">{{ salesBinderIcon }}</mat-icon><span class="menu-label">{{ 'NAV.SYNC_SB' | translate }}</span>
              </button>
            </li>
          }
        </ul>
        <div class="sidebar-footer">
          <app-language-toggle></app-language-toggle>
          <button type="button" class="latest-version"
            (click)="appVersionService.updatePanelOpen = !appVersionService.updatePanelOpen"
            [attr.aria-expanded]="appVersionService.updatePanelOpen"
            [attr.aria-label]="'Versión ' + latestVersion + '. Abrir opciones de actualización'"
            matTooltip="Actualizar aplicación">
            {{ latestVersion }}
          </button>
        <button
          class="sidebar-toggle"
          mat-icon-button
          type="button"
          (click)="toggleSidebarCompact()"
          [attr.aria-label]="isSidebarCompact ? 'Expandir menú' : 'Contraer menú'"
          [matTooltip]="isSidebarCompact ? 'Expandir menú' : 'Contraer menú'"
          [matTooltipDisabled]="sidenavMode !== 'side'"
          matTooltipPosition="right">
          <mat-icon aria-hidden="true">{{ isSidebarCompact ? 'chevron_right' : 'chevron_left' }}</mat-icon>
        </button>
        </div>
      </div>
    </mat-sidenav>
    <mat-sidenav-content class="left content" [class.immersive-mobile]="isImmersiveMobileRoute"
      [style.margin-left]="sidenavMode === 'side' && !fullSize ? 'calc(var(--sidebar-current-width) + var(--sidebar-inset))' : '0px'">
      @if (!fullSize && sidenavMode === 'side') {
        <app-home-user-tool></app-home-user-tool>
      }
      <div class="children_shadow" [class.immersive-mobile]="isImmersiveMobileRoute">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
  <div class="mobile-sidenav-swipe-edge" aria-hidden="true"></div>
</div>
<p-toast position="top-right" appendTo="body"></p-toast>
